import { useState, useEffect } from 'react'
import { useGetHeaderInfoQuery } from '@core/app/api/profileApi'

const useIsEmployee = () => {
    const { data: headerInfo } = useGetHeaderInfoQuery({})
    const [isEmployee, setIsEmployee] = useState<boolean | null>(null)

    useEffect(() => {
        if (headerInfo) {
            const isSubstitute = headerInfo?.data?.Substitute === 1
            setIsEmployee(isSubstitute)
        }
    }, [headerInfo])

    return { isEmployee }
}

export default useIsEmployee
